import { Dispatch } from 'redux';

import { Action } from '../types/action';
import { AppState } from '../types/app-state';
import { login, logout, session } from '../services/auth';
import { destroyState } from '../utils/localStorage';
import * as Constants from './auth.constants';

export interface LoginAction extends Action {
  email: string;
}

export interface LoginSuccessAction extends Action {
  token: string;
  uid: string;
  sysadmin: boolean;
  newUser: boolean;
}

export interface LoginFailedAction extends Action {
  message: string;
}

export interface TokenRefreshAction extends Action {
  token: string;
}

export function VerifySession() {
  return async (dispatch: Dispatch<any>, getState: () => AppState) => {
    try {
      dispatch({ type: Constants.VERIFY_SESSION });
      const { token } = getState().auth;
      if (!token) {
        // do nothing
        return;
      }
      const { status, message } = await session(token);
      if (status !== 1) {
        throw new Error(status === -2 ? 'Invalid session' : message);
      }
    } catch (error) {
      dispatch(InvalidateSession());
    }
  };
}

export function InvalidateSession(): Action {
  destroyState();
  return {
    type: Constants.INVALIDATE_SESSION
  };
}

export function Login(email: string, password: string) {
  return async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: Constants.LOGIN, email });
      const { status, data, message } = await login(email, password);
      if (status === 1 && data && data.token) {
        dispatch(LoginSuccess(data.token, data.uid, data.sysadmin, data.newUser));
      } else {
        throw new Error(status === -2 ? message : 'A server error occurred.');
      }
    } catch (error) {
      dispatch(LoginFailed(error.message));
    }
  };
}

export function LoginSuccess(
  token: string,
  uid: string,
  sysadmin: boolean = false,
  newUser: boolean = false
): LoginSuccessAction {
  return {
    type: Constants.LOGIN_SUCCESS, token, uid, sysadmin, newUser
  };
}



export function LoginFailed(message: string): LoginFailedAction {
  return {
    type: Constants.LOGIN_FAILED, message
  };
}

export function TokenRefresh(token: string) {
  return async (dispatch: Dispatch<any>, getState: () => AppState) => {
    dispatch({ type: Constants.TOKEN_REFRESH, token });
  };
}

export function Logout() {
  return async (dispatch: Dispatch<any>, getState: () => AppState) => {
    try {
      dispatch({ type: Constants.LOGOUT });
      const { token } = getState().auth;
      if (token) {
        // await logout(token);
        logout(token);
      }
      // success or not, we should clear the client state
      dispatch(InvalidateSession());
    } catch (error) {
      dispatch(InvalidateSession());
    }
  };
}

export type All
  = Action
  | LoginAction
  | LoginSuccessAction
  | LoginFailedAction
  | TokenRefreshAction;